// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"438":"52f25c11","453":"a8b49705"}[chunkId] + ".chunk.js";
};